import http from '../http';
import { formatArrayQueries, errorPayload, successPayload } from '@/services/formatter';

const dataParamsContruct = (data) => ({
  isReadAfterWrite: data.isReadAfterWrite || false,
  search: data.searchParameter,
});

async function getTableData(filters = {}) {
  const queries = formatArrayQueries(filters);
  const queryString = queries ? `?${queries}` : '';

  const params = dataParamsContruct(filters);

  try {
    const response = await http({
      url: `/resolve-formulas/grid/${queryString}`,
      method: 'get',
      params,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
}

async function getResolveFormulaListData(filters = {}) {
  const queries = formatArrayQueries(filters);
  const queryString = queries ? `?${queries}` : '';

  const params = dataParamsContruct(filters);

  try {
    const response = await http({
      url: `/resolve-formulas/${queryString}`,
      method: 'get',
      params,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
}

async function getResolveFormula(id) {
  try {
    const response = await http({
      url: `/resolve-formulas/${id}`,
      method: 'get',
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
}

async function updateResolveFormula(id, data) {
  try {
    const response = await http({
      url: `/resolve-formulas/${id}`,
      method: 'patch',
      data,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
}

async function addResolveFormula(data) {
  try {
    const response = await http({
      url: `/resolve-formulas`,
      method: 'post',
      data,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
}

async function deleteResolveFormula(id) {
  try {
    const response = await http({
      url: `/resolve-formulas/${id}`,
      method: 'delete',
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
}

async function getResolveFormulaExpressionComponents(filters = {}) {
  const queries = formatArrayQueries(filters);
  const queryString = queries ? `?${queries}` : '';

  const params = dataParamsContruct(filters);

  try {
    const response = await http({
      url: `/resolve-formulas/expression/components${queryString}`,
      method: 'get',
      params,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
}

export {
  getTableData,
  getResolveFormulaListData,
  addResolveFormula,
  deleteResolveFormula,
  getResolveFormula,
  updateResolveFormula,
  getResolveFormulaExpressionComponents,
};
